import { Workshop } from '@/@types/workshop'

export function isWorkshopExpired(workshop?: Workshop, now: Date = new Date()): boolean {
  if (!workshop) return false

  const startDate = workshop.start ? new Date(workshop.start) : null
  const endDate = workshop.end ? new Date(workshop.end) : null

  if (!startDate || !endDate) return false

  const nowTime = now.getTime()
  const startTime = startDate.getTime()
  const endTime = endDate.getTime()

  const isActive = nowTime >= startTime && nowTime <= endTime
  const hasEnded = nowTime > endTime

  return !isActive && hasEnded
}
